var exports = {
  "nP": "flexContainer-QUg3T",
  "p_": "list-QUg3T",
  "gX": "center-QUg3T",
  "kb": "left-QUg3T",
  "Nr": "card-QUg3T",
  "VM": "titleInfo-QUg3T",
  "GG": "showcase-QUg3T",
  "Qs": "content-QUg3T",
  "E9": "infoArea-QUg3T",
  "Pf": "label-QUg3T",
  "DD": "title-QUg3T",
  "Z5": "topContainer-QUg3T",
  "xL": "creator-QUg3T",
  "Tg": "textArea-QUg3T",
  "VA": "subtitle-QUg3T",
  "tu": "bottomContainer-QUg3T",
  "TG": "origin-QUg3T",
  "qr": "footer-QUg3T",
};

module.exports = exports;
